import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';

const NotFoundPage = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title;

  return (
    <Layout location={location} title={siteTitle}>
      <SEO title="404: Not Found" />
      <h1>Not Found</h1>
      <p>Sorry, this page doesn't exist.</p>
      <p>
        Looking for <strong>fluentvalidation-ts</strong>? You'll find it at its new home:{' '}
        <a href="https://fluentvalidation-ts.alexpotter.dev/">
          https://fluentvalidation-ts.alexpotter.dev/
        </a>
      </p>
    </Layout>
  );
};

export default NotFoundPage;

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`;
